import { useState, useEffect, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  PageContainer,
  PageHeader,
  DataCard
} from '@/components/common'
import { FileUploadZone } from '@/components/upload/FileUploadZone'
import { UploadsList } from '@/components/upload/UploadsList'
import { DataPreview } from '@/components/upload/DataPreview'
import { useUploadStore } from '@/stores/uploadStore'
import { useAuth } from '@/contexts/AuthContext'
import { Upload } from '@/types'

export function DriverUploadPage() {
  const navigate = useNavigate()
  const [selectedUpload, setSelectedUpload] = useState<Upload | null>(null)
  const { currentUser } = useAuth()

  const {
    uploads,
    loadUploads
  } = useUploadStore()

  useEffect(() => {
    if (currentUser) {
      loadUploads(currentUser)
    }
  }, [currentUser, loadUploads])

  const handleUploadComplete = useCallback((uploadId?: string) => {
    if (uploadId) {
      navigate(`/forare/upload/workflow/${uploadId}`)
    }
  }, [navigate])

  const handleViewData = (upload: Upload) => {
    setSelectedUpload(upload)
  }

  const driverUploads = useMemo(
    () => uploads.filter(upload => upload.platform === 'driver_import'),
    [uploads]
  )

  return (
    <PageContainer>
      <PageHeader
        title="Bulkuppladdning av förare"
        subtitle="Ladda upp en CSV- eller Excel-fil för att skapa eller uppdatera flera förare samtidigt."
      />

      <DataCard title="Ladda upp fil">
        <FileUploadZone
          platform="driver_import"
          onUploadComplete={handleUploadComplete}
        />
      </DataCard>

      <UploadsList
        uploads={driverUploads}
        onViewData={handleViewData}
      />

      <DataPreview
        upload={selectedUpload}
        open={selectedUpload !== null}
        onClose={() => setSelectedUpload(null)}
      />
    </PageContainer>
  )
}

